import { render, staticRenderFns } from "./ErrorIcon.vue?vue&type=template&id=2fd96e5c&scoped=true"
import script from "./ErrorIcon.vue?vue&type=script&lang=js"
export * from "./ErrorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd96e5c",
  null
  
)

export default component.exports